var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#E60023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C18.125 12.5 12.5 18.125 12.5 25C12.5 30.1562 15.625 34.5312 20 36.4062C20 35.4687 20 34.5312 20.1562 33.5938C20.4687 32.5 21.7187 26.7188 21.7187 26.7188C21.7187 26.7188 21.25 25.9375 21.25 24.6875C21.25 22.8125 22.3438 21.4062 23.5938 21.4062C24.6875 21.4062 25.3125 22.1875 25.3125 23.2812C25.3125 24.375 24.5312 26.0938 24.2188 27.6563C23.9062 28.9063 24.8438 30 26.25 30C28.5938 30 30.1563 27.0312 30.1563 23.2812C30.1563 20.4687 28.2813 18.4375 25 18.4375C21.25 18.4375 18.9063 21.25 18.9063 24.375C18.9063 25.4688 19.2188 26.25 19.6875 26.875C19.8438 27.1875 20 27.1875 19.8437 27.5C19.8437 27.6563 19.6875 28.2813 19.5312 28.4375C19.375 28.75 19.2188 28.9062 18.9063 28.75C17.1875 27.9687 16.4062 26.0938 16.4062 23.9062C16.4062 20.3125 19.375 16.0938 25.3125 16.0938C30.1562 16.0938 33.2812 19.5312 33.2812 23.2812C33.2812 28.125 30.625 31.875 26.5625 31.875C25.1563 31.875 23.9062 31.0938 23.4375 30.3125C23.4375 30.3125 22.6562 33.125 22.5 33.75C22.1875 34.6875 21.7188 35.625 21.25 36.4062C22.3438 36.7187 23.5937 36.875 24.8437 36.875C31.7187 36.875 37.3437 31.25 37.3437 24.375C37.5 18.125 31.875 12.5 25 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/Pinterest.77891187275447366a76419ef798ef67.svg";
export { ForwardRef as ReactComponent };